<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <path
            d="M15.2195 4.92603L12.5334 6.94464L9.35742 9.32712V11.9462L15.9612 6.98741C15.9612 6.97755 15.9628 6.96849 15.9628 6.95862C15.9628 6.13439 15.7151 5.45741 15.2195 4.92603Z"
            fill="#FF8800"
        />
        <path
            d="M15.1316 10.2458C15.0245 10.1874 14.911 10.1355 14.7908 10.087L12.7492 11.608C12.9674 11.8251 13.0777 12.1147 13.0777 12.4774C13.0777 12.9019 12.932 13.2424 12.6389 13.4613C12.3467 13.6801 11.9087 13.7895 11.3243 13.7895H7.59073V6.12053H11.1226C11.5853 6.12053 11.9474 6.23322 12.2092 6.45778C12.3632 6.5894 12.4702 6.75227 12.5335 6.94393L15.2196 4.92532C15.0584 4.75258 14.8714 4.59464 14.6574 4.45315C13.7865 3.87735 12.5163 3.58862 10.8485 3.58862H4.47363V16.3386H10.7933C12.6447 16.3386 14.0565 16.0285 15.0312 15.4099C16.005 14.7905 16.4923 13.8923 16.4923 12.7143C16.4923 12.1435 16.3795 11.6524 16.154 11.2386C15.9284 10.8257 15.5877 10.495 15.1308 10.2466L15.1316 10.2458Z"
            fill="black"
        />
    </svg>
</template>
